<script>
  import { onMount } from "svelte";

  let canvas;
  let ctx;
  const canvasHorizontalPadding = 50;
  let canvasVerticalPadding = 50;
  const canvasWordSpace = 20;
  const canvasRowSpace = 20;

  export let modals;
  export let price;
  export let style;
  export let color;
  export let variants;
  export let closeout = false;
  let imagesReady = false;

  $: if (style == "Script") {
    canvasVerticalPadding = 10;
  } else {
    canvasVerticalPadding = 50;
  }

  //TODO: Make this a class?
  //TODO: Implement promise or async/await?
  //TODO: Handle image.onerror.
  let imageQueue = {
    imagesWaiting: 0,
    allImagesRequested: false,
    _callback: undefined,
    add: function(img, src) {
      this.imagesWaiting += 1;
      img.onload = () => {
        this.dec();
      };
      img.onerror = function(e) {
        console.error(e);
      };
      img.src = src;
    },
    _checkDone: function() {
      if (this.allImagesRequested && !this.imagesWaiting) {
        this._callback();
      }
    },
    dec: function() {
      this.imagesWaiting -= 1;
      this._checkDone();
    },
    doneAdding: function(callback) {
      this._callback = callback;
      this.allImagesRequested = true;
      this._checkDone();
    }
  };

  function getImages() {
    imagesReady = false;
    for (let row of variants) {
      for (let word of row) {
        for (let letter of word) {
          letter.jsImg = new Image();
          imageQueue.add(letter.jsImg, letter.image);
        }
      }
    }
    imageQueue.doneAdding(() => {
      imagesReady = true;
      updateCanvas();
    });
  }

  function updateCanvas() {
    if (!(ctx && imagesReady)) {
      // updateCanvas may get called by getImages before ctx is defined.
      // We can expect onMount also to call updateCanvas once ctx is defined.
      return;
    }
    let rowWidths = [];
    let rowHeights = [];
    let wordCounts = [];
    for (let row of variants) {
      let rowWidth = 0;
      let rowHeight = 0;
      wordCounts.push(row.length);
      for (let word of row) {
        for (let letter of word) {
          rowWidth += letter.jsImg.width;
          if (letter.jsImg.height > rowHeight) {
            rowHeight = letter.jsImg.height;
          }
        }
      }
      rowHeights.push(rowHeight);
      rowWidths.push(rowWidth + canvasWordSpace * (row.length - 1));
    }

    canvas.width = Math.ceil(
      2 * canvasHorizontalPadding + Math.max(...rowWidths)
    );
    canvas.height = Math.ceil(
      2 * canvasVerticalPadding +
        rowHeights.reduce((acc, curr) => acc + curr) +
        (variants.length - 1) * canvasRowSpace
    );
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (style != "Script") {
      ctx.shadowColor = "rgba(0,0,0,0.2)";
      ctx.shadowBlur = 8;
      ctx.shadowOffsetX = 4;
      ctx.shadowOffsetY = 4;
    }
    let y = canvasVerticalPadding;
    let counter = 0;
    for (let row of variants) {
      let x =
        canvasHorizontalPadding +
        (Math.max(...rowWidths) - rowWidths[counter]) / 2;
      for (let word of row) {
        for (let letter of word) {
          ctx.drawImage(letter.jsImg, x, y);
          x += letter.jsImg.width;
        }
        x += canvasWordSpace;
      }
      //TODO: Check previous row height. For now: assume 100.
      y += 100 + canvasRowSpace;
      counter += 1;
    }
  }

  //Cents int to padded decimal string.
  function priceToStr(price) {
    let strPrice = "";
    if (price < 10) {
      strPrice = "00" + price;
    } else if (price < 100) {
      strPrice = "0" + price;
    } else {
      strPrice = "" + price;
    }
    return strPrice.substr(0, strPrice.length - 2) + "." + strPrice.substr(-2);
  }

  let addToCartQueue = [];

  function addToCartClick() {
    modals = [{ message: "Adding your custom phrase to the cart..." }];
    // return;
    let variantIds = variants.flat(2).map(x => x.id);
    let phraseCount = variantIds.length;
    variantIds = new Set(variantIds);
    let customPhrase = [];
    for (let word of variants.flat(1)) {
      customPhrase.push(word.map(x => x.letter).join(""));
    }
    //TODO: Maybe customPhrase should just be exactly what they entered
    //in the textarea.
    customPhrase = customPhrase.join(" ");
    for (let id of variantIds) {
      let qty = variants.flat(2).filter(x => x.id == id).length;
      addToCartQueue.push({
        quantity: qty,
        id: id,
        properties: {
          "Custom Phrase": customPhrase
        }
      });
    }
    processCartQueue();
  }

  function processCartQueue() {
    if (addToCartQueue.length) {
      shopifyAddItem(addToCartQueue.shift());
    } else {
      modals = [];
      document.location.href = "/cart";
    }
  }

  async function shopifyAddItem(item) {
    const rawResponse = await fetch("/cart/add", {
      method: "POST",
      credentials: "include",
      mode: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(item)
    });
    const content = await rawResponse.json();
    if (content.status !== undefined) {
      console.error("Could not add custom phrase to cart.");
      alert("There was a problem adding your custom phrase balloons.");
    } else {
      processCartQueue();
    }
  }

  onMount(() => {
    ctx = canvas.getContext("2d");
    updateCanvas();
  });

  $: getImages(variants);

  $: if (canvas) {
    if (style == "Standard") {
      canvas.style.width = `${canvas.width * 0.6}px`;
    } else if (style == "Script") {
      canvas.style.width = `${canvas.width * 1.25}px`;
    } else {
      canvas.style.removeProperty("width");
    }
  }
</script>

<style>
  .custom-package {
    display: inline-block;
    padding-right: 1em;
    vertical-align: middle;
  }
  canvas {
    border: 1px solid black;
    max-width: 50vw;
    max-height: 300px;
  }
</style>

<div class="custom-package">
  <canvas bind:this={canvas} width={300} height={150} />
  <br />
  {#if style == 'Jumbo'}
    {#if closeout}CLOSEOUT{/if}
    34″ Tall - {color} -
    <strong>${priceToStr(price)}</strong>
  {:else if style == 'Standard'}
    {#if closeout}CLOSEOUT{/if}
    14″ Tall - {color} -
    <strong>${priceToStr(price)}</strong>
  {:else}
    {#if closeout}CLOSEOUT{/if}
    {color} -
    <strong>${priceToStr(price)}</strong>
  {/if}
  <br />
  <button on:click={addToCartClick}>Add To Cart</button>
  <br />
  &nbsp;
</div>
